import { AxiosErrorHandler } from 'ui';
import { PublicEventSkeleton } from '../components';
import { useNodeEventQuery } from '../queries';
import { PublicEventContent } from './public-event-content';

type P = {
  eventId: string;
};

const PublicEvent = ({ eventId }: P) => {
  const {
    data: event,
    error: eventError,
    isFetching: isFetchingEvent,
  } = useNodeEventQuery({ eventId, skipAuth: true }, { throwOnError: false });

  return (
    <AxiosErrorHandler error={eventError}>
      {isFetchingEvent || !event ? <PublicEventSkeleton /> : <PublicEventContent event={event} />}
    </AxiosErrorHandler>
  );
};

export default PublicEvent;
